import React, { useState } from "react";
import SubmittedFormData from "../SubmittedFormData";
import DataTable from "../Reusable/DataTable";
import APIS from "../../constant/Endpoint";
import NACell from "../Reusable/DataTable/NACell";
import { DeleteIcon } from "../../Icons/DeleteIocn";
import Modal from "../Reusable/Modal";
import ConfirmDialog from "../ConfirmDialog";
import ResolveData from "../Reusable/ResolvedData";

const DataCollection = (props: any) => {
  const { data, handleDelete } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [selectedObject, setSelectedObject] = useState(null);
  const handleColDelete = (getValue: any) => {
    setSelectedObject(getValue);
    setIsOpen(true);
  };
  const defaultColumns = [
    {
      header: "Company Name",
      accessorKey: "company_name",
      cell: ResolveData,
    },
    {
      header: "Email",
      accessorKey: "email",
      cell: ResolveData,
    },
    {
      header: "Phone Number",
      accessorKey: "phone_number",
      cell: ResolveData,
    },
    {
      header: "Action",
      accessorKey: "id",
      cell: ({ row, getValue }) => (
        <>
          <div className="flex gap-2 justify-center">
            <button onClick={() => handleColDelete(getValue)}>
              {/* <img src={DeleteIcon} alt="" className="text-indigo-300" /> */}
              <DeleteIcon color={"var(--primary)"} />
            </button>
          </div>
        </>
      ),
    },
  ];
  return (
    <>
      {/* <SubmittedFormData
        fields={data?.form_field}
        formId={data?.form}
        handleDelete={handleDelete}
      /> */}
      <DataTable
        columns={defaultColumns}
        url={`${APIS.FORM_DATA}`}
        params={{}}
        queryKey={`form_data`}
        tableName={"form-data"}
      />
      <Modal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        children={
          <ConfirmDialog
            setIsOpen={setIsOpen}
            handleDelete={() => handleDelete(setIsOpen, selectedObject)}
          />
        }
        title="Delete"
      />
    </>
  );
};
export default DataCollection;
